module.exports = __webpack_public_path__ + "static/img/3.395f00e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/3.png
// module id = LE/H
// module chunks = 0